import React, { useLayoutEffect, useState, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";

import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { OwnerShipService } from "../../../apis/apiServices/OwnerShip";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faEye,
  faRefresh,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

export default function PurchaseDetailComponent() {
  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Purchase Details ";
    getOwnershipList();
  }, []);

  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [OwnershipList, setOwnershipList] = useState([]);
  const [Ownership, SetOwnership] = useState({
    id: 0,
    name: "",
    code: "",
    isActive: true,
  });

  const getOwnershipList = async () => {
    try {
      const response = await OwnerShipService.getOwnerShipList();
      setOwnershipList(response?.data);

    } catch (error) {
      console.log("Error getCityList===>", error);
    }
  };

  useEffect(() => {
    getOwnershipList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const newErrors = {};
    if (!Ownership.name) newErrors.name = "OwnerShip Type is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }
  

    try {
      let body = {
        id: Ownership.id,
        name: Ownership?.name || "",
        code: Ownership?.code || "",
        isActive: Ownership?.isActive || false,
        ModifiedBy: 0,
      };

      const response = await OwnerShipService.addOwnerShip(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        return;
      }

      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        window.location.href = `/OwnerShiptype`;
      });
  
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    SetOwnership({
      id: 0,
      name: "",
      code: "",
      isActive: true,
    });
  };

  const handleInputChange = (e, field) => {
    SetOwnership((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div
      // style={{
      //     display: 'inline-flex',
      //     alignItems: 'center',
      //     padding: '0px 11px',
      //     borderRadius: '9999px',
      //     fontWeight: 500,
      //     color: isActive ? '#15803d' : '#dc2626',
      //     backgroundColor: isActive ? '#dcfce7' : '#fee2e2',
      //     fontSize: '14px',
      //     width: 'fit-content'
      // }}
      >
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };
  const handleRowClick = (e) => {
    SetOwnership({
      id: e.data.id,
      name: e.data.name,
      code: e.data.code,
      isActive: e.data.isActive,
    });
  };
  const handledelete = (e) => {
    Swal.fire({
      title: "Do you want to Delete Record?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Saved!", "", "success");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content  align-items-center">
                  <button
                    className="btn btn-primary btn-sm mr-1"
                    onClick={openModal}
                    title="Add"
                  >
                    <i className="fas fa-plus"></i> Add
                  </button>
                  <button
                    className="btn bg-blue btn-sm"
                    onClick={() => getOwnershipList()}
                    title="Refresh"
                  >
                    <FontAwesomeIcon icon={faRefresh} /> Refresh
                  </button>
                </div>
                <DataGrid
                  dataSource={OwnershipList}
                  columnAutoWidth={true}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  onRowClick={(e) => handleRowClick(e)}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                >
                  <HeaderFilter visible={false} />
                  <Column
                    caption={""}
                    cellRender={(cellData) => {
                      return (
                        <span>
                          <FontAwesomeIcon
                            icon={faPen}
                            className="pr-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsCityModalOpen(true)}
                          />

                          <FontAwesomeIcon
                            icon={faEye}
                            className="pl-2"
                            style={{ cursor: "pointer" }}
                            // onClick={() => { navigate("/user/view/", { state: cellData?.data }) }}
                          />
                          <FontAwesomeIcon
                            icon={faTrash}
                            className="pl-2"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => handledelete(e)}
                          />
                        </span>
                      );
                    }}
                  ></Column>

                  <Column
                    dataField="code"
                    caption="Code"
                    allowFiltering={false}
                  />
                  <Column
                    dataField="name"
                    caption="Name"
                    allowFiltering={false}
                  />
                  <Column
                    dataField="isActive"
                    caption="Status"
                    cellRender={renderStatusCell}
                    alignment="left"
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />

                  <Export enabled={false} fileName="Vendors" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isCityModalOpen}
         className="react-modal custom-modal-small"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Ownership Type Modal"
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            {/* <div className="modal-title">{uom.stateId  ? "Update UOM" : "New UOM"}</h6> */}
          </div>

          <div className="modal-body">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Code </label>
                  <TextBox
                    className={`form-control ${
                      errors.code ? "is-invalid" : ""
                    }`}
                    placeholder="Enter code"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Ownership.code}
                    onValueChanged={(e) => handleInputChange(e, "code")}
                  />
                  {errors.code && (
                    <div className="error invalid-feedback">{errors.code}</div>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <label>
                    {" "}
                    Ownership Type <span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className={`form-control ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Ownership Type"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Ownership.name}
                    onValueChanged={(e) => handleInputChange(e, "name")}
                  />
                  {errors.name && (
                    <div className="error invalid-feedback">{errors.name}</div>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                {/* <div className="form-group">
                                <label>Description </label>
                                <TextBox
                                    className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                    placeholder="Enter Description"
                                    showClearButton={true}
                                    valueChangeEvent="keyup"
                                    value={Ownership.description}
                                    onValueChanged={(e) => handleInputChange(e, "description")}
                                />
                                {errors.description && (
                                    <div className="error invalid-feedback">{errors.description}</div>
                                )}
                            </div> */}
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <CheckBox
                  text="Is Active"
                  value={Ownership.isActive}
                  onValueChanged={(e) => handleInputChange(e, "isActive")}
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit">Submit</span>
              )}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
